module.exports = __webpack_public_path__ + "static/logo-sc-admin-c5d081d41f151dd411fc3ff19eec0e57.svg";